import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/product';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import React, { useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import TextBox from 'theme/TextBox';

const ProductSearch = () => {
  const [keyword, setKeyword] = useState('');
  const [redirect, setRedirect] = useState(false);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      setRedirect(true);
    }
  };

  if (redirect) {
    return (
      <Redirect
        to={{
          pathname: $R.PRODUCT_LIST.path,
          search: '?search_text=' + keyword,
        }}
      />
    );
  }

  return (
    <div className='container-fluid user-search headerMargin'>
      <div className='user-search__container'>
        <div className='row user-search__header-container'>
          <div className='col-xs-12 col-md-7 input-area align-self-center'>
            <div className='input-area__label-wrapper'>
              <label className='label-title'>{$ST.SEARCH_PRODUCT}</label>
            </div>
            <div className='input-area__input-wrapper'>
              <TextBox
                name='customer'
                type='text'
                autoComplete='off'
                placeholder={`${$ST.ENTER_PRODUCT_CODE}`}
                value={keyword}
                onKeyPress={(e) => handleKeyPress(e)}
                onChange={(value) => setKeyword(value.trim())}
              />
            </div>
          </div>
          <div className='col-xs-12 col-md-5 align-self-center'>
            <Link
              to={{
                pathname: $R.PRODUCT_LIST.path,
                search: '?search_text=' + keyword,
              }}
              className='button pointer text-center user-find-button'
            >
              {$ST.SEARCH}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSearch;



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/product/search/index.js